var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.4542C-0.66667 14.9146 -0.666666 11.0656 2 9.52599L18.5 -0.000293732V25.9805L2 16.4542Z",
    fill: "#1D3647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupAngle);
export default __webpack_public_path__ + "static/media/popup_angle.1780e843704326fe70e096869815d4ef.svg";
export { ForwardRef as ReactComponent };